import { useFetch } from '../api/hooks'
import { useCallback, useEffect } from 'react'

const STABLE_ARRAY = []

const useRequestedTasks = () => {
  const [request, { loading, called, result }] = useFetch('Error fetching assigned tasks')

  const getTasks = useCallback(async () => {
    return request({
      method: 'get',
      url: `/user/requested-tasks`,
    })
  }, [request])

  useEffect(() => {
    getTasks()
  }, [getTasks])

  return {
    requestedTasks: result || STABLE_ARRAY,
    loading: loading || !called,
    refresh: getTasks,
  }
}

export default useRequestedTasks
